<div>
  <div class="col-md-12 divPrincipal">
    <div class="container">

      <h1 class="mat-h1 divTitulo">
        <span class="spanDom">Smart</span> <span class="spanCloud"> DOM</span> - <span class="spanDom">
          {{nombreMuni | uppercase}}</span>
      </h1>
      <h2 class="subTitulo">
        Tus trámites de obra en línea
      </h2>
    </div>

    <div class="container">
      <div class="form-row">
        <form [formGroup]="contrasenas">
          <div>
            <div class="form-row">
              <h4>
                Restablecer contraseña.
              </h4>
              <p>
                Ingrese los campos requeridos para crear su contraseña nueva.
              </p>
            </div>
            <div>
             <!--  <div class="form-row">
                <mat-form-field class="inputlogin">
                  <input matInput placeholder="Rut" id="rut" name="rut" formControlName="rut" formatRut
                    [errorStateMatcher]="matcher" minlength="9">
                  <mat-error *ngIf="contrasenas.controls?.rut.hasError('required')">
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                  <mat-error *ngIf="contrasenas.controls?.rut.hasError('invalidRut')">
                    Este rut es <strong>inválido</strong>
                  </mat-error>
                </mat-form-field>
              </div> -->
              <div class="form-row">
                <mat-form-field class="inputlogin">
                  <input [type]="hide2 ? 'password' : 'text'" matInput placeholder="Ingrese nueva contraseña"
                    formControlName="contrasena" required>
                  <mat-icon matSuffix (click)="hide2 = !hide2">
                    {{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  <mat-error *ngIf="contrasenas.controls?.contrasena.hasError('required')">
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                  <mat-error *ngIf="contrasenas.controls?.contrasena.errors?.MatchPassword">
                    Las contraseñas deben <strong>conincidir</strong>.
                  </mat-error>
                  <mat-error *ngIf="contrasenas.controls?.contrasena.hasError('minlength')">
                    La contraseña debe tener <strong>más de 6 caracteres</strong>.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="inputlogin">
                  <input [type]="hide3 ? 'password' : 'text'" matInput placeholder="Repita la nueva contraseña"
                    formControlName="repContrasena" required>
                  <mat-icon matSuffix (click)="hide3 = !hide3">
                    {{hide3 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  <mat-error *ngIf="contrasenas.controls?.repContrasena.hasError('required')">
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                  <mat-error *ngIf="contrasenas.controls?.repContrasena.errors?.MatchPassword">
                    Las contraseñas deben <strong>conincidir</strong>.
                  </mat-error>
                  <mat-error *ngIf="contrasenas.controls?.repContrasena.hasError('minlength')">
                    La contraseña debe tener <strong>más de 6 caracteres</strong>.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row" style="display: grid;">
                <mat-dialog-actions align="end">
                  <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
                    style="margin-right: 2%;" (click)="dialog.closeAll()">Cancelar</button>
                  <button mat-raised-button color="primary" id="ingreso_ampliacion"
                    [disabled]="contrasenas.status == 'INVALID'" (click)="restablecer()">Restablecer <i
                      class="fa fa-user-o " aria-hidden="true "></i></button>
                </mat-dialog-actions>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>

<ng-template #passResp>
  <h2 mat-dialog-title>Recuperación de contraseña</h2>
  <mat-dialog-content>
    <p>Se pudo establecer su nueva contraseña.</p>
    <p>En estos momentos será redireccionado al login.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
      (click)="redirect()">Aceptar</button>

  </mat-dialog-actions>
</ng-template>

<ng-template #passNoResp>
  <h2 mat-dialog-title>Recuperación de contraseña</h2>
  <mat-dialog-content>
    <p>Ha ocurrido un problema con la recuperación de su contraseña.</p>
    <p>Por favor, intente más tarde.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
      (click)="dialog.closeAll()">Aceptar</button>
  </mat-dialog-actions>
</ng-template>